import { config } from "./Config";
import { PerformanceChartAPI } from "./Api";
import { ChartPerformance } from "./Chart";
import { PerformanceFilters } from "./Filters";

export class ProductPerformanceChart {
  constructor() {
    this.elements = {
      container: document.querySelector(
        config.performanceChartContainerSelector
      ),
    };
  }

  get currentConfig() {
    return this.chartConfig;
  }

  async init() {
    if (!this.elements.container) {
      console.warn(
        `${config.performanceChartContainerSelector} selector not found, component not created`
      );
      return;
    }

    this.filtersPerformance = new PerformanceFilters();
    this.filtersPerformance.init();

    await this.renderChart();
    this.bindEvents();
  }

  async renderChart() {
    const config = await this.prepareConfig();

    this.chartInstance = new ChartPerformance(config.data || {});
    this.chartInstance.createChart(config.data);

    if (!config.data || !Object.keys(config.data).length) {
      return setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("performanceChartNoDataLoaded", {})
        );
      });
    }
  }

  async prepareConfig() {
    const chartConfig = JSON.parse(
      this.elements.container.getAttribute("chart-config")
    );

    const endpoint = chartConfig.endpointAction;

    const performanceAPI = new PerformanceChartAPI({
      endpoint,
    });

    const { response } = await new Promise(async (resolve, reject) => {
      try {
        const response = await performanceAPI.loadData();
        resolve({ response });
      } catch (err) {
        reject(err);
      }
    });

    this.chartConfig = {
      data: response,
      endpoint,
    };
    chartConfig.data = response;

    return chartConfig;
  }

  async loadData() {
    const performanceAPI = new PerformanceChartAPI({
      endpoint: this.chartConfig.endpoint,
    });

    return await new Promise(async (resolve, reject) => {
      try {
        const response = await performanceAPI.loadData();
        this.chartInstance.reloadChart(response);
        resolve({ response });
      } catch (err) {
        reject(err);
      }
    });
  }

  async handleFiltersChange({ value }) {
    const performanceAPI = new PerformanceChartAPI({
      endpoint: this.chartConfig.endpoint,
    });

    const { startDate, endDate, name } =
      this.filtersPerformance.getCurrentFilterConfig(value);

    return await new Promise(async (resolve, reject) => {
      try {
        const response = await performanceAPI.loadData(startDate, endDate);
        this.chartInstance.reloadChart(response);

        resolve({
          response,
          filter: {
            startDate,
            endDate,
            name,
          },
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  async handleDateChange({ startDate, endDate }) {
    const performanceAPI = new PerformanceChartAPI({
      endpoint: this.chartConfig.endpoint,
    });

    return new Promise(async (resolve, reject) => {
      try {
        const response = await performanceAPI.loadData(startDate, endDate);
        this.chartInstance.reloadChart(response);
        resolve({
          response,
        });
      } catch (err) {
        reject();
      }
    });
  }

  reload() {
    this.chartInstance.reload();
  }

  bindEvents() {}
}
